/** A small seeded random (the same sky on every page and every load, so nothing jumps). */
function seeded(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Scattered over the screen: one star in each cell of a 6×4 grid, at a random place inside it (none in a line, none in a heap). */
const STARS = (() => {
  const rnd = seeded(20261013);
  const cols = 6;
  const rows = 4;
  return Array.from({ length: cols * rows }, (_, i) => {
    const c = i % cols;
    const r = Math.floor(i / cols);
    return { l: ((c + 0.12 + rnd() * 0.76) / cols) * 100, t: ((r + 0.12 + rnd() * 0.76) / rows) * 97, s: 1 + rnd() * 1.4, du: 2.4 + rnd() * 3.2, dl: rnd() * 5 };
  });
})();

/**
 * The site's sky behind every game page (the home page's, approved for all): twinkling stars over
 * the dark gradient and the faint grid (CSS on the body). No rising embers (the owner's choice). Off
 * with reduced motion and in light mode.
 */
export function SiteSky() {
  return (
    <div className="site-sky" aria-hidden>
      {STARS.map((s, i) => (
        <i key={i} className="site-sky__star" style={{ left: `${s.l}%`, top: `${s.t}%`, width: s.s, height: s.s, animationDuration: `${s.du}s`, animationDelay: `${s.dl}s` }} />
      ))}
    </div>
  );
}

const EMBERS = (() => {
  const rnd = seeded(77);
  return Array.from({ length: 14 }, (_, i) => ({ l: ((i + 0.15 + rnd() * 0.7) / 14) * 100, t: 72 + rnd() * 22, s: 3 + rnd() * 4, du: 4 + rnd() * 4, dl: rnd() * 5, dx: Math.round(-40 + rnd() * 80) }));
})();

/** Embers rising from the bottom: only on the home page and the match map (the owner's choice). */
export function RisingEmbers({ scale = 1 }: { scale?: number }) {
  return (
    <div className="site-embers" aria-hidden>
      {EMBERS.map((s, i) => (
        <i key={i} className="rmap__ember" style={{ left: `${s.l}%`, top: `${s.t}%`, width: s.s * scale, height: s.s * scale, ['--dx' as string]: `${s.dx * scale}px`, ['--rise' as string]: `${-420 * scale}px`, animationDuration: `${s.du}s`, animationDelay: `${s.dl}s` }} />
      ))}
    </div>
  );
}
